document.addEventListener('DOMContentLoaded', () => {

    const targetElement = document.querySelector('.product-single__meta');
    const stickyButtonContainer = document.querySelector('.sticky-btn__container');

    // Ensure the elements exist
if (targetElement && stickyButtonContainer) {
    // Define the observer options
    const options = {
        root: null, // Use the viewport as the root
        threshold: 0 // Trigger as soon as the target is no longer visible
    };

    // Define the callback function
    const observerCallback = (entries) => {
        entries.forEach(entry => {
            // Check if the element is not visible and has been scrolled past (below)
            if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                // When scrolled past the target, add the class
                stickyButtonContainer.classList.add('sticky-atc-btn__active');
            } else {
                // Otherwise, remove the class
                stickyButtonContainer.classList.remove('sticky-atc-btn__active');
            }
        });
    };

    // Create the observer
    const observer = new IntersectionObserver(observerCallback, options);

    // Start observing the target element
    observer.observe(targetElement);
}

    let stickySelects = document.querySelectorAll('.sticky-atc-btn__select');
    if (stickySelects.length > 0){

        stickySelects.forEach((stickySelect) => {            
            stickySelect.addEventListener('change', () => {
                getSelectedOptions();
                getSelectedVariant(stickySelect);
                if(this.currentVariant){
                    updateURL(stickySelect);
                    updateFormID();
                }
            })
        })  
        
        const getSelectedOptions = () => {
            this.options = Array.from(stickySelects, (select) => select.value)
        }

        const getVariantJSON = (stickySelect) => {
            let variantData = JSON.parse(stickySelect.querySelector('[type="application/json"]').textContent);
            return variantData;
        }

        const getSelectedVariant = (stickySelect) => {
            this.currentVariant = getVariantJSON(stickySelect).find(
                (variant) => {
                    const findings = !variant.options.map(
                        (option, index) => {
                            return this.options[index] == option;
                        }
                    ).includes(false);

                    if(findings) return variant;
                }
            );

            console.log(currentVariant);
        }

        const updateURL = (stickySelect) => {
            if(!this.currentVariant) return;

            let datasetURL = stickySelect.dataset.url;
            window.history.replaceState({}, '', `${datasetURL}?variant=${this.currentVariant.id}`);
        }

        const updateFormID = () => {
            const form_input = document.querySelector('#sticky-atc-btn__form').querySelector('input[name="id"]');
            form_input.value = this.currentVariant.id;
        }

    }    
})